import { AttributeTreeData } from '@/models/reports/attribute-tree-data';
import { AggregateFunction } from '@/models/reports/report-column-aggregate-function';

export class DisplayColumn {
    public column: AttributeTreeData;
    public aggregateType?: AggregateFunction | null;

    public get isAggregate() {
        return this.aggregateType != null && this.aggregateType !== 6;
    }

    public constructor(column: AttributeTreeData, aggregateType?: AggregateFunction | null) {
        this.column = column;
        this.aggregateType = aggregateType;
    }
}
